$(document).ready(function () {

  if ($(".c-share-page__links").length > 0) {
    // On clicks of media icons
    $(".c-share-page__link").click(function () {
      var sharelink = $(this).attr("data-sharelink");
      var url = $(this).attr("data-url");
      window.open(
        sharelink + url,
        "_blank",
        "height=400,width=600,menubar=0,resizable=1,toolbar=0,location=0",
        true
      );
    });
  }
});
